//// https://medium.com/@amanda.k.hussey/a-basic-tutorial-on-how-to-incorporate-speech-recognition-with-react-6dff9763cea5
//// https://developer.mozilla.org/en-US/docs/Web/API/SpeechRecognition

import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";

import Loader from '../../Loader/Loader.jsx';
import TextToSpeech from './TextToSpeech.jsx';
import AuthButtons from "../../UI/AuthButtons.jsx";

import { useStore } from '../../../hook-store/store.js';

import { 
  TEXTAUDIOTOOLSNODE_URL,
  ollamaNodeJsUrl,
} from "../../../App.js";

import './SpeechToTextLongTime.css';
import { marks } from '../../../utils/marks.jsx';



const SpeechToTextLongTime = () => {

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  const [transcript, setTranscript] = useState("");
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);

  const [responseText, setResponseText] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  let detectedLanguage = navigator.languages[0];
  const lsUserSelectLng = localStorage.getItem('userSelectLng');

  if (lsUserSelectLng) {
    detectedLanguage = lsUserSelectLng;
  }

  
  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      // console.warn('Web Speech API is not supported in this browser.');
      const alertMessage = `${t("textVoiceAssistant12", "This browser does not support this voice input. Please try different browsers.")}`;
      alert(alertMessage)
      return
    };

    const recognition = new SpeechRecognition();
    recognition.continuous = true; // Essential for long sessions

    recognition.interimResults = true;

    if (detectedLanguage) {
      recognition.lang = detectedLanguage;
    }

    recognition.onresult = (event) => {
      let finalTranscript = "";
      for (let i = event.resultIndex; i < event.results.length; i++) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript + " ";
        }
      }

      // console.log('onresult transcript', finalTranscript, transcript)
      setTranscript((prev) => prev + finalTranscript);
    };

    recognition.onend = () => {
      // Restart loop: If isListening is true but API ends, restart it
      // console.log('onend transcript', transcript)
      if (isListening) {
        recognition.start();
      }

      // console.log('onend', recognitionRef.current)
      setIsListening(false);
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error:', event.error);
      setIsListening(false);
    };

    recognitionRef.current = recognition;
  }, [isListening]);

  const toggleListening = () => {
    if (isListening) {
      recognitionRef.current.stop();
      setIsListening(false);
    } else {

      setTranscript('');

      recognitionRef.current.start();
      setIsListening(true);
    }
  };



    const sendSpeechTextHandler = async (text, url) => {
      try {
        setIsLoading(true);
        setErrorMessage('');
  
        // dispatch('SET_MLSPEECHISUSERGENERATING', true);
        // // throw new Error('error-error')
        
  
        const formData = new FormData();
        const sendText = text + ' ?'
        formData.append('fSttText', sendText);

        // formData.append('textText', sendText);
  
        // console.log(text);
        // throw new Error('error-error')
  
        const url = ollamaNodeJsUrl + `/ollama-mcp-text-voice-assistant/post-text-voice-assistant`;
        const result = await fetch(url, {
          method: 'POST',
          headers: {
            // 'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          body: formData,
        });

        if (!result.ok) {
          throw new Error('error occured');
        }
  
        const resData = await result.json();
        console.log(result, resData);


  
        if (resData && resData.data && resData.data.llmResponse) {
          setResponseText(resData.data.llmResponse);
        }
  
        setIsLoading(false);
  
        // setTimeout(() => {
        //   dispatch('SET_MLSPEECHISUSERGENERATING', false);
        // },1000*20);
  
      }
       catch(err) {
        console.log(err);
        setIsLoading(false);
        setErrorMessage('Response failed');
        
        // dispatch('SET_MLSPEECHISUSERGENERATING', false);
        // setTimeout(() => {
        //   dispatch('SET_MLSPEECHISUSERGENERATING', false);
        // },1000*20);
        
        throw err;
      }
    }


  return (
    <div className='sttLongTime'
    // style={{border: "1px solid red"}}
    >
      <div className='sttLongTimeRow'>
        <button className='btnBase'
        onClick={toggleListening}
        >
          {isListening && (
            <span>
              <span style={{color: "gray"}}>
                  {marks.microphoneSlashMark} 
              </span>
              <span>
                {' '}{t("textVoiceAssistant05", "Stop voice input")}
              </span>
            </span>
          )}
          {!isListening && (
            <span>
              <span style={{color: "gray"}}>
                  {marks.microphoneMark} 
              </span>
              <span>
                {' '}{t("textVoiceAssistant06", "Start voice input")}
              </span>
            </span>
          )}
        </button>
        {isListening && (
          <span
            className='fading-text'
            style={{color: "gray"}}
          > 
          {marks.microphoneMark}
          </span>
        )}
      </div>
      <div className='sttLongTimeRow'>
        <div className='sttLongTimeTranscript'
        // style={{ border: '1px solid #ccc', padding: '10px', marginTop: '10px' }}
        >
          <p>
            {t("textVoiceAssistant07", "User input")}:{' '}
            <strong>
              {transcript}
            </strong>
          </p>
        </div>

        <div>
          <button
            onClick={() => {
              setTranscript('');
            }}
          >
            {t("textVoiceAssistant08", "Clear input")}
          </button>
        </div>
      </div>

      <div className='sttLongTimeRow'>
        <button className='sttLongTimeActionButton'
        // className='btnBase'
          disabled={isLoading || !transcript || !isAuth}
          onClick={() => {
            sendSpeechTextHandler(transcript);
          }}
        >
          {t("textVoiceAssistant03", "Ask to assistant")}
        </button>
      </div>
      {isLoading && (
        <Loader />
      )}
      {errorMessage && (
        <div style={{color:"red"}}>
          {errorMessage}
        </div>
      )}

      {!isAuth && (
        <div>
          <div className='textToTextRow'>
            Login is required.
          </div>
          <div className='textToTextRow'>
            <AuthButtons />
          </div>
        </div>
      )}

      <div  
      // style={{ padding: '20px', border: "1px solid green" }}
      >
        <TextToSpeech 
          responseText={responseText}
        />
      </div>

    </div>
  );
};

export default SpeechToTextLongTime;